import rose_red from "../Image/rose_red.jpg";
import red_rose_ from "../Image/red_rose_.jpg";
import rose_blue from "../Image/rose_blue.jpg";
import blue_rose_ from "../Image/blue_rose_.jpg";
import rose_yellow from "../Image/rose_yellow.jpg";
import yellow_rose_ from "../Image/yellow_rose_.jpg";
import rose_pink from "../Image/rose_pink.jpg";
import pink_rose_ from "../Image/pink_rose_.jpg";
import rose_purple from "../Image/rose_purple.jpg";
import violet_rose_ from "../Image/violet_rose_.jpg";
import rose_black from "../Image/rose_black.jpg";
import black_rose_ from "../Image/black_rose_.jpg";
import rose_deepPink from "../Image/rose_deepPink.jpg";
import deeppink_rose_ from "../Image/deeppink_rose_.jpg";
import tulip_red from "../Image/tulip_red.jpg";
import red_tulip_ from "../Image/red_tulip_.jpg";
import tulip_blue from "../Image/tulip_blue.jpg";
import blue_tulip_ from "../Image/red_tulip_.jpg";
import tulip_yellow from "../Image/tulip_yellow.jpg";
import yellow_tulip_ from "../Image/yellow_tulip_.jpg";
import carnaition from "../Image/carnaition.jpg";
import carnaition_ from "../Image/carnaition_.jpg";
import bottan from "../Image/bottan.jpg";
import bottan_ from "../Image/bottan_.jpg";
import sunflower from "../Image/sunflower.jpg";
import sunflower_ from "../Image/sunflower_.jpg";
import hydrangea_purple from "../Image/hydrangea_purple.jpg";
import hydrangea_blue from "../Image/hydrangea_blue.jpg";
import emerald_rose from "../Image/emerald_rose.jpg";
import emerald_rose_ from "../Image/emerald_rose_.jpg";
import miniFlower from "../Image/miniFlower.jpg";
import miniFlower_ from "../Image/miniFlower_.jpg";

export const FlowerData = [
  {
    img: rose_red,
    title: "Rose (red)",
    modal: red_rose_,
  },
  {
    img: rose_blue,
    title: "Rose (blue)",
    modal: blue_rose_,
  },
  {
    img: rose_yellow,
    title: "Rose (yellow)",
    modal: yellow_rose_,
  },
  {
    img: rose_pink,
    title: "Rose (pink)",
    modal: pink_rose_,
  },
  {
    img: rose_purple,
    title: "Rose (violet)",
    modal: violet_rose_,
  },
  {
    img: rose_black,
    title: "Rose (black)",
    modal: black_rose_,
  },
  {
    img: rose_deepPink,
    title: "Rose (deep pink)",
    modal: deeppink_rose_,
  },
  {
    img: tulip_red,
    title: "Tulip (red)",
    modal: red_tulip_,
  },
  {
    img: tulip_blue,
    title: "Tulip (blue)",
    modal: blue_tulip_,
  },
  {
    img: tulip_yellow,
    title: "Tulip (yellow)",
    modal: yellow_tulip_,
  },
  {
    img: carnaition,
    title: "Carnaition",
    modal: carnaition_,
  },
  {
    img: bottan,
    title: "Bottan",
    modal: bottan_,
  },
  {
    img: sunflower,
    title: "Sunflower",
    modal: sunflower_,
  },
  {
    img: hydrangea_purple,
    title: "hydrange (purple)",
    modal: hydrangea_purple,
  },
  {
    img: hydrangea_blue,
    title: "hydrange (blue)",
    modal: hydrangea_blue,
  },
  {
    img: emerald_rose,
    title: "rose (emerald)",
    modal: emerald_rose_,
  },
  {
    img: miniFlower,
    title: "mini flowers",
    modal: miniFlower_,
  },
];
